module.exports = __webpack_public_path__ + "media/images/ui__textArrowUpLight--dark-48906114dcfffbd2aef0c0a75e3cfb96.png";